import { CompanyDTO } from "@energy-advice/easas-api";
import { APIResponse } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";

class CompanyApiDefinition extends ApiDefinition {
  constructor() {
    super("/companies");
  }

  async getCompanies(): Promise<APIResponse<CompanyDTO[]>> {
    return this.get();
  }

  async updateCompany(company: CompanyDTO): Promise<APIResponse<CompanyDTO>> {
    return this.put(`${company.companyReference}/by-ref`, company);
  }
}

export const CompanyApi = new CompanyApiDefinition();
